import { ArrowLeft, Paper, Video } from "@bale/ui";
import styles from "./TutorialItem.module.scss";
import { formatStrings, openLinkInNewPage } from "utils/utils";
import { strings } from "intl/fa";
import { useTheme } from "@emotion/react";
import { Tutorial, TutorialsType } from "./tutorials";
import { useState } from "react";
import PlayerModal from "components/commons/modal/playerModal/PlayerModal";
import ImageWithLoader from "components/commons/imageWithLoader/ImageWithLoader";

type Props = {
  tutorial: Tutorial;
};

export function TutorialItem(props: Props) {
  const theme = useTheme();
  const [showPlayerModal, setShowPlayerModal] = useState(false);
  const isArticle = props.tutorial.type === TutorialsType.Article;
  const clickHandler = () => {
    if (isArticle) {
      openLinkInNewPage(props.tutorial.link);
    } else {
      setShowPlayerModal(true);
    }
  };
  return (
    <>
      <div className={styles.Item} onClick={clickHandler}>
        <div className={styles.ImageWrapper}>
          <ImageWithLoader
            className={styles.Image}
            src={props.tutorial.img}
            alt="tutor"
          />
          {!isArticle && (
            <img
              className={styles.PlayIcon}
              src={"/icons/next.svg"}
              alt="tutor"
            />
          )}
          <div className={styles.CategoryIcon}>
            <div className={styles.Icon}>
              {isArticle ? (
                <Paper size={16} color={theme.colors.light[0]} />
              ) : (
                <Video size={16} color={theme.colors.light[0]} />
              )}
            </div>
          </div>
        </div>
        <div className={styles.DescWrapper}>
          <div className={styles.Title}>{props.tutorial.name}</div>
          <div className={styles.Click}>
            <p>
              {formatStrings(strings.tutorials.cards.call_to_action, {
                text: isArticle
                  ? strings.tutorials.cards.read_article
                  : strings.tutorials.cards.watch_video,
              })}
            </p>
            <ArrowLeft size={18} color={theme.colors.dark[300]} />
          </div>
        </div>
      </div>
      {showPlayerModal && (
        <PlayerModal
          onClose={() => setShowPlayerModal(false)}
          aparatLink={props.tutorial.link}
          title={props.tutorial.name}
        />
      )}
    </>
  );
}
